import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { isoStringToDate } from './timezone';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    const sValue = String(value);

    // Support DD/MM/YYYY
    if (sValue.includes('/')) {
      const parts = sValue.split('/');
      if (parts.length === 3) {
        return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      }
    }

    // Support YYYY-MM-DD (via robust helper)
    if (sValue.includes('-')) {
      return isoStringToDate(sValue);
    }

    const timestamp = typeof value === 'number' ? value : Date.parse(sValue);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  override deserialize(value: unknown): Date | null {
    if (typeof value === 'string') {
      return this.parse(value);
    }
    return super.deserialize(value);
  }

  override format(date: Date, displayFormat: unknown): string {
    // Override standard formats to ensure dd/MM/yyyy
    if (typeof displayFormat === 'string') {
      if (displayFormat === 'dd/MM/yyyy' || displayFormat === 'input') {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${this._to2digit(day)}/${this._to2digit(month)}/${year}`;
      }
    }

    // Handle the specific format object from ES_CO_DATE_FORMATS
    if (typeof displayFormat === 'object' && displayFormat !== null && 'dateInput' in displayFormat) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${this._to2digit(day)}/${this._to2digit(month)}/${year}`;
    }

    return super.format(date, displayFormat as object);
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}
